import React, { useState } from "react";
import * as Mui from "@mui/material";
import * as Icons from "react-feather";
import { Task } from "model/task";
import { FeatherIcon } from "component/shared/feather-icon";


interface Props {
	task: Task;
	disabled: boolean;
	theme: Mui.Theme;
	classes: Record<string, string>;
	onTogglePriority: () => void;
	onDelete: () => void;
	onEdit: () => void;
}

export const TaskCardRight: React.FC<Props> = ({
	task,
	disabled,
	theme,
	classes,
	onTogglePriority,
	onDelete,
	onEdit,
}) => {
	const { type, priority } = task;
	const flagColor = theme.palette.primary.main;
	const flagFill = priority ? theme.palette.primary.main : "none";
	const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

	const handleMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
		event.stopPropagation();
		setAnchorEl(event.currentTarget);
	};

	const handleMenuClose = (event?: React.MouseEvent) => {
		if (event) {
			event.stopPropagation();
		}
		setAnchorEl(null);
	};

	const handleEdit = (event: React.MouseEvent) => {
		event.stopPropagation();
		handleMenuClose();
		onEdit();
	};

	const handleDelete = (event: React.MouseEvent) => {
		event.stopPropagation();
		handleMenuClose();
		onDelete();
	};

	return (
		<div className={classes.rightSection}>
			{type && (
				<Mui.Chip
					icon={<type.icon size={16} />}
					label={type.name}
					className={`${classes.typeChip} ${classes.typeChipDesktop}`}
				/>
			)}
			<Mui.IconButton
				onClick={onTogglePriority}
				disabled={disabled}
				className={classes.iconButton}
			>
				<Icons.Flag
					className={classes.flagIcon}
					size={24}
					color={flagColor}
					fill={flagFill}
				/>
			</Mui.IconButton>
			<Mui.IconButton
				className={`delete ${classes.iconButton}`}
				onClick={handleMenuOpen}
				disabled={disabled}
			>
				<Icons.MoreVertical className={classes.moreIcon} size={24} />
			</Mui.IconButton>
			<Mui.Menu
				anchorEl={anchorEl}
				open={Boolean(anchorEl)}
				onClose={() => handleMenuClose()}
				anchorOrigin={{
					vertical: "bottom",
					horizontal: "right",
				}}
				transformOrigin={{
					vertical: "top",
					horizontal: "right",
				}}
			>
				<Mui.MenuItem onClick={handleEdit}>
					<Mui.ListItemIcon>
						<Icons.Edit size={20} />
					</Mui.ListItemIcon>
					<Mui.ListItemText primary="Edit" />
				</Mui.MenuItem>
				<Mui.MenuItem onClick={handleDelete}>
					<Mui.ListItemIcon>
						<Icons.Trash2 size={20} />
					</Mui.ListItemIcon>
					<Mui.ListItemText primary="Delete" />
				</Mui.MenuItem>
			</Mui.Menu>
		</div>
	);
};
